import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { LEAD_TYPES } from "../services/leadEmail";
import { submitLegacyLead } from "../services/legacyLeadSubmission";

function KugaFullHybrid() {
  const navigate = useNavigate();
  const conversionSendTo = "AW-17814485194/HOcACLil1d0bEMrxza5C";

  const form = useForm();
  const { register, handleSubmit, formState } = form;
  const { errors } = formState;

  const marketingCampaign = async (data, slug) => {
    try {
      await submitLegacyLead({
        collectionName: slug,
        formData: data,
        firestoreData: {
          name: data.name ?? "",
          email: data.email ?? "",
          phone: data.phone ?? "",
          dealership: data.dealership ?? "",
          text: "",
          model: "KugaFullHybrid",
          copy: "ralitsa.lyubenova@motopfohe.bg",
        },
        leadPayload: {
          type: LEAD_TYPES.CAMPAIGN_OFFER,
          vehicle: {
            model: "Kuga Full Hybrid",
          },
          campaign: {
            slug,
          },
          title: "kuga-full-hybrid-march-2026-campaign",
          message: "Запитване за Kuga Full Hybrid",
        },
      });

      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: conversionSendTo,
        });
      }

      navigate("/thank-you-testdrive");
    } catch (error) {
      console.error("Грешка при запис в Firebase:", error);
    }
  };

  const renderContactForm = () => {
    const slug = "kuga-full-hybrid-march-2026-campaign";

    return (
      <form
        onSubmit={handleSubmit((data) => marketingCampaign(data, slug))}
        id="templateCampaignForm"
        className="px-8 py-16 lg:px-48"
        noValidate
      >
        <h2 className="text-xl tracking-wider text-center uppercase text-fordBlue">
          Поискай оферта
        </h2>

        {/* Име */}
        <div className="mt-8">
          <label htmlFor="name" className="text-gray-500">
            Име
          </label>
          <input
            type="text"
            id="name"
            name="name"
            {...register("name", {
              required: {
                value: true,
                message: "Моля, въведете Вашето име",
              },
            })}
          />
          <p className="text-red-500">{errors.name?.message}</p>
        </div>

        {/* Имейл */}
        <div className="mt-4">
          <label htmlFor="email" className="text-gray-500">
            Имейл
          </label>
          <input
            type="email"
            id="email"
            name="email"
            {...register("email", {
              required: {
                value: true,
                message: "Моля, въведете имейл-адрес",
              },
              pattern: {
                value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                message: "Невалиден имейл-адрес",
              },
            })}
          />
          <p className="text-red-500">{errors.email?.message}</p>
        </div>

        {/* Телефон */}
        <div className="mt-4">
          <label htmlFor="phone" className="text-gray-500">
            Телефон
          </label>
          <input
            type="text"
            id="phone"
            name="phone"
            {...register("phone", {
              required: {
                value: true,
                message: "Моля, въведете телефонен номер",
              },
              pattern: {
                value:
                  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
                message: "Невалиден телефонен номер",
              },
            })}
          />
          <p className="text-red-500">{errors.phone?.message}</p>
        </div>

        <div className="mt-4">
          <label htmlFor="dealership" className="text-gray-500">
            Предпочитано представителство
          </label>
          <select
            name="dealership"
            id="dealership"
            {...register("dealership", {
              required: {
                value: true,
                message: "Моля, изберете представителство",
              },
            })}
          >
            <option value="" disabled>
              Моля, изберете
            </option>
            <option value="liulin2@motopfohe.bg">София Люлин</option>
            <option value="mladost@motopfohe.bg">София Младост</option>
            <option value="blagoevgrad@motopfohe.bg">Благоевград</option>
            <option value="burgas@motopfohe.bg">Бургас</option>
            <option value="varna@motopfohe.bg">Варна</option>
            <option value="velikotarnovo@motopfohe.bg">Велико Търново</option>
            <option value="gabrovo@motopfohe.bg">Габрово</option>
            <option value="dobrich@motopfohe.bg">Добрич</option>
            <option value="montana@motopfohe.bg">Монтана</option>
            <option value="pleven@motopfohe.bg">Плевен</option>
            <option value="plovdiv@motopfohe.bg">Пловдив</option>
            <option value="russe@motopfohe.bg">Русе</option>
            <option value="starazagora@motopfohe.bg">Стара Загора</option>
            <option value="smolyan@motopfohe.bg">Смолян</option>
            <option value="forsh@motopfohe.bg">Шумен</option>
          </select>
          <p className="text-red-500">{errors.dealership?.message}</p>
        </div>

        {/* Скрито поле за заглавие на кампанията */}
        <input
          type="hidden"
          name="title"
          value="kuga-full-hybrid-march-2026-campaign"
        />

        <button
          type="submit"
          className="px-16 py-2 mx-auto mt-8 text-white border rounded-full bg-fordBlue"
        >
          Изпрати
        </button>
      </form>
    );
  };

  const ytHeroRef = useRef(null);
  const ytInlineRef = useRef(null);
  const [shouldLoadInlineVideo, setShouldLoadInlineVideo] = useState(false);
  useEffect(() => {
    const start = 0;
    const end = 18;
    let player;
    let intervalId;

    const createPlayer = () => {
      const parentWidth =
        ytHeroRef.current?.parentElement?.clientWidth || window.innerWidth;
      const playerWidth = Math.max(320, Math.round(parentWidth));
      const playerHeight = Math.max(180, Math.round((playerWidth * 9) / 16));

      player = new window.YT.Player(ytHeroRef.current, {
        height: String(playerHeight),
        width: String(playerWidth),
        videoId: "6XC2dy7ldf4",
        playerVars: {
          autoplay: 1,
          mute: 1,
          controls: 0,
          rel: 0,
          start,
          playsinline: 1,
          modestbranding: 1,
        },
        events: {
          onReady: (e) => e.target.playVideo(),
          onStateChange: (e) => {
            if (e.data === window.YT.PlayerState.PLAYING) {
              if (intervalId) clearInterval(intervalId);
              intervalId = setInterval(() => {
                const current = player.getCurrentTime();
                if (current >= end) player.seekTo(start, true);
              }, 250);
            }
          },
        },
      });
    };

    const loadYouTubeAPI = () => {
      if (window.YT && window.YT.Player) {
        createPlayer();
      } else {
        window.onYouTubeIframeAPIReady = createPlayer;
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(tag);
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadYouTubeAPI();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 },
    );

    if (ytHeroRef.current) {
      observer.observe(ytHeroRef.current);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (player && player.destroy) player.destroy();
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const inlineVideoNode = ytInlineRef.current;
    if (!inlineVideoNode) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShouldLoadInlineVideo(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.35 },
    );

    observer.observe(inlineVideoNode);

    return () => observer.disconnect();
  }, []);

  return (
    <main className="w-full min-h-screen text-fordBlue font-fordAntennaRegular">
      {/* Video */}
      <motion.div
        className="relative w-full overflow-hidden aspect-[16/9]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <div
          id="heroVideo"
          ref={ytHeroRef}
          className="absolute inset-0 w-full h-full [&_iframe]:w-full [&_iframe]:h-full"
        ></div>

        <div className="absolute text-white top-[5%] left-[3%] hidden lg:block">
          <h1 className="text-6xl font-fordBlack">НОВИЯТ FORD KUGA ХИБРИД</h1>
          <p className="mt-4 text-4xl">
            СЕГА С ЕКСКЛУЗИВЕН ЕКО БОНУС ДО 5000 € / 9779,80 лв.
          </p>
        </div>

        <div className="absolute hidden bottom-[10%] left-1/2 -translate-x-1/2 lg:flex justify-center text-center margin-auto">
          <button
            className="px-12 pt-3 pb-2 text-2xl tracking-wide uppercase bg-white border rounded-full text-fordBlue lg:mt-auto border-fordLight hover:bg-fordBlue hover:text-white"
            onClick={() => {
              const ofertaSection = document.getElementById("poiskayOferta");
              if (ofertaSection) {
                ofertaSection.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
            }}
          >
            Поискай оферта
          </button>
        </div>
      </motion.div>
      <div className="px-4 py-8 text-white bg-fordBlue lg:hidden">
        <h1 className="text-2xl font-fordBlack">НОВИЯТ FORD KUGA ХИБРИД</h1>
        <p className="text-xl">
          СЕГА С ЕКСКЛУЗИВЕН ЕКО БОНУС ДО 5000 € / 9779,80 лв.
        </p>
        <button
          className="px-4 py-2 mt-4 bg-white rounded-full text-fordBlue"
          onClick={() => {
            const ofertaSection = document.getElementById("poiskayOferta");
            if (ofertaSection) {
              ofertaSection.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          }}
        >
          Поискай оферта
        </button>
      </div>
      {/* Акценти */}
      <div className="grid grid-cols-1 gap-4 px-4 py-8 lg:grid-cols-2 lg:auto-rows-fr">
        <div className="h-full overflow-hidden bg-gray-100 rounded-2xl text-fordBlue">
          <article className="flex flex-col h-full lg:flex-row">
            <div className="h-56 md:h-64 lg:h-auto lg:w-1/2">
              <img
                src="/images/kuga4990/ford-kuga-blue-front-view.jpg"
                alt=""
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-8 lg:w-1/2">
              <h3 className="text-3xl tracking-wide">Нова визия</h3>
              <p className="mt-4 mb-8 hyphens-auto">
                Новият Ford Kuga впечатлява с освежен екстериорен дизайн,
                съче­таващ елегантност и динамика. Подчертаната предна решетка,
                новите LED светлини и прецизно оформените аеродинамични линии
                придават силен визуален отпечатък.
              </p>
            </div>
          </article>
        </div>

        <div className="h-full overflow-hidden bg-gray-100 rounded-2xl text-fordBlue">
          <article className="flex flex-col h-full lg:flex-row">
            <div className="h-56 md:h-64 lg:h-auto lg:w-1/2">
              <img
                src="/images/kuga4990/eco-and-effective.jpg"
                alt=""
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-8 lg:w-1/2">
              <h3 className="text-3xl tracking-wide">Икономичен и ефективен</h3>
              <p className="mt-4 mb-8 hyphens-auto">
                Предлага се във версия със самозареждаща се хибридна система и
                2.5 литров двигател. С възможен пробег до 1018 км.*
              </p>
            </div>
          </article>
        </div>

        <div className="h-full overflow-hidden bg-gray-100 rounded-2xl text-fordBlue">
          <article className="flex flex-col h-full lg:flex-row-reverse">
            <div className="h-56 md:h-64 lg:h-auto lg:w-1/2">
              <img
                src="/images/kuga4990/ford-kuga-light-detail.jpg"
                alt=""
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-8 lg:w-1/2">
              <h3 className="text-3xl tracking-wide">LED фарове</h3>
              <p className="mt-4 mb-8 hyphens-auto">
                Оборудван с модерни LED предни светлини, които не само
                осигу­ряват по-добра осветеност на пътя, но и придават на
                автомобила разпознаваем, запомнящ се облик.
              </p>
            </div>
          </article>
        </div>

        <div className="h-full overflow-hidden bg-gray-100 rounded-2xl text-fordBlue">
          <article className="flex flex-col h-full lg:flex-row-reverse">
            <div className="h-56 md:h-64 lg:h-auto lg:w-1/2">
              <img
                src="/images/kuga4990/wheels.jpg"
                alt=""
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-8 lg:w-1/2">
              <h3 className="text-3xl tracking-wide">
                Джанти с изразителен дизайн
              </h3>
              <p className="mt-4 mb-8 hyphens-auto">
                Новите стилни джанти на Ford Kuga допринасят за още
                по-уникал­ния и динамичен силует на автомобила. Създадени с
                внимание към детайла, те подчертават спортния характер и
                индивидуалност на всяка серия – Titanium, ST-Line или Active.
              </p>
            </div>
          </article>
        </div>
      </div>

      {/* Connectivity */}
      <div className="relative">
        <picture>
          <source
            media="(max-width: 768px)"
            srcSet="/images/kuga4990/ford-kuga-interior-mobile.jpg"
          />
          <img
            src="/images/kuga4990/ford-kuga-interior.jpg"
            alt=""
            className="w-full h-auto"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute bottom-[5%] left-[5%] text-white lg:w-1/3">
          <h3 className="text-3xl">Още по-усъвършенстван.</h3>
          <p className="mt-2">
            Новият 13.2-инчов сензорен екран SYNC 4 предлага още повече
            свързаност – с безжичен Apple CarPlay или Android Auto, 5G модем и
            безжични актуализации
          </p>
        </div>
      </div>
      {/* Pulling power */}
      <div className="relative mt-8">
        <picture>
          <source
            media="(max-width: 768px)"
            srcSet="/images/kuga4990/ford-kuga-pulling-power-mobile.jpg"
          />
          <img
            src="/images/kuga4990/ford-kuga-pulling-power.jpg"
            alt="Ford Kuga pulling power"
            className="w-full h-auto"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-transparent"></div>
        <div className="absolute top-[5%] left-[3%] lg:left-[80%] lg:-translate-x-1/2 text-white lg:w-1/3 z-10">
          <h3 className="text-2xl tracking-wide">Повече теглителна мощ</h3>
          <p className="mt-2">
            Хибридният Ford Kuga осигурява впечатляваща теглителна способност до
            2 100 кг¹. Вградените данни и карти изчисляват маршрути, подходящи
            за теглене, за да стигнеш до приключението без компромис.
          </p>
        </div>
      </div>
      {/* 3 columns text */}
      <div className="flex flex-col gap-4 p-4 my-4 lg:flex-row">
        <div className="flex-1 p-8 text-white bg-fordBlue rounded-2xl">
          <h3 className="text-3xl tracking-wide min-h-[4.5rem]">
            Допълнително пространство
          </h3>
          <p className="mt-4 hyphens-auto">
            Комфортният интериор включва оптимизиран дизайн и регулируеми задни
            седалки. Плъзнете задните седалки назад за допълнително пространство
            за краката или напред за до 536 литра багажно пространство.
          </p>
        </div>
        <div className="flex-1 p-8 text-white bg-fordBlue rounded-2xl">
          <h3 className="text-3xl tracking-wide min-h-[4.5rem]">
            Асистент за мъртва точка
          </h3>
          <p className="mt-4 hyphens-auto">
            Системата за асистенция в мъртвата точка (Blind Spot Assist) на Ford
            Kuga следи зоните, които не виждаш в огледалата и ти помага да
            сменяш лентите по-безопасно.
          </p>
        </div>
        <div className="flex-1 p-8 text-white bg-fordBlue rounded-2xl">
          <h3 className="text-3xl tracking-wide min-h-[4.5rem]">
            Асистент за проверка преди потегляне
          </h3>
          <p className="mt-4 hyphens-auto">
            Trailer Checklist на Ford Kuga винаги си сигурен, че всичко е в
            готовност преди потегляне. Системата ти напомня да провериш ключови
            елементи, свързани с ремаркето – като светлини, връзки, спирачки и
            налягане в гумите.
          </p>
        </div>
      </div>
      {/* Интелигентни технологии */}
      <h2 className="pt-16 pb-8 text-4xl tracking-wider text-center text-fordBlue">
        Интелигентни технологии
      </h2>
      <div className="flex flex-col gap-4 px-4 py-8 lg:flex-row ">
        <div className="flex-1 overflow-hidden bg-gray-100 text-fordBlue rounded-2xl">
          <img
            src="/images/kuga4990/inteligent-navigation.jpg"
            alt=""
            className="mb-4"
          />
          <div className="p-8">
            <h3 className="text-3xl tracking-widemin-h-[4.5rem]">
              Интелигентна навигация
            </h3>
            <p className="mt-4 mb-8 hyphens-auto">
              С интелигентната навигация на Ford Kuga винаги си на най-добрия
              маршрут. Системата използва в реално време информация за трафика и
              пътните условия, за да ти предложи най-ефективния и безопасен път
              до целта.
            </p>
          </div>
        </div>
        <div className="flex-1 overflow-hidden bg-gray-100 text-fordBlue rounded-2xl">
          <img
            src="/images/kuga4990/rearview-camera.jpg"
            alt=""
            className="mb-4"
          />
          <div className="p-8">
            <h3 className="text-3xl tracking-wide min-h-[4.5rem]">
              Задна камера
            </h3>
            <p className="mt-4 mb-8 hyphens-auto">
              Камерата за задно виждане със 180° широк изглед осигурява пълна
              видимост на зоната зад автомобила при движение на заден ход.
              Динамичните указателни линии и интелигентните функции – забавяне
              на изображението, мащабиране и визуализация на ултразвуковите
              сензори – улесняват паркирането и повишават безопасността.
            </p>
          </div>
        </div>
        <div className="flex-1 overflow-hidden bg-gray-100 text-fordBlue rounded-2xl">
          <img
            src="/images/kuga4990/ford-kuga-blue-front-view.jpg"
            alt=""
            className="mb-4"
          />
          <div className="p-8">
            <h3 className="text-3xl tracking-wide  min-h-[4.5rem]">
              Увереност при всяко пресичане
            </h3>
            <p className="mt-4 mb-8 hyphens-auto">
              Системата за помощ при пресичане (Intersection Assist) на новия
              Ford Kuga добавя още едно ниво на сигурност в натовареното градско
              движение. Тя следи пътната обстановка при приближаване към
              кръстовище и автоматично спира автомобила, ако засече потенциален
              сблъсък с пресичащи превозни средства.
            </p>
          </div>
        </div>
      </div>

      <section className="flex flex-col items-center px-4 py-12 lg:justify-center lg:p-16 lg:flex-row">
        <a href="https://sale.ford.bg/?fuel=%D0%91%D0%B5%D0%BD%D0%B7%D0%B8%D0%BD%2F%D0%A5%D0%B8%D0%B1%D1%80%D0%B8%D0%B4&model=KUGA">
          <button className="px-12 py-2 mx-8 text-white border rounded-full border-fordLight bg-fordLight hover:bg-fordBlue hover:text-white">
            Виж налични автомобили
          </button>
        </a>
      </section>

      <section
        className="w-full px-4 py-4 xl:w-[1300px] mx-auto"
        ref={ytInlineRef}
      >
        <div className="w-full overflow-hidden rounded-2xl aspect-video">
          {shouldLoadInlineVideo ? (
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/cgobzFgipIc?autoplay=1&mute=1&controls=0&rel=0&playsinline=1&loop=1&playlist=cgobzFgipIc"
              title="Kuga Full Hybrid видео"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          ) : (
            <div className="w-full h-full bg-black/5" />
          )}
        </div>
      </section>

      <motion.section
        id="poiskayOferta"
        className="w-full xl:w-[1300px] mx-auto py-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, delay: 1.3 }}
      >
        {renderContactForm()}
      </motion.section>

      <p className="max-w-4xl px-2 mx-auto text-sm text-gray-500">
        Офертата е валидна от 03.03 до 31.03.2026г. или до изчерпване на
        количествата.
      </p>
      <p className="max-w-4xl px-2 mx-auto text-sm text-gray-500">
        *Посоченият пробег от 1018 км е изчислен при среден разход от 5,3л/
        100км ** и капацитет на резервоара от 54 л. Реалният пробег може да се
        различава в зависимост от индивидуалния стил на шофиране, пътните
        условия, натоварването на на автомобила и климатичните фактори.
      </p>
      <p className="max-w-4xl px-2 mx-auto text-sm text-gray-500">
        **Посоченият разход е изчислен въз основа на сертифицирани данни по WLTP
        за Kuga FHEV FWD TITANIUM.
      </p>
    </main>
  );
}

export default KugaFullHybrid;
